import React from 'react';
import { BaseModal } from './BaseModal';
import { ContactForm } from './ContactForm';

interface ContactFormModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ContactFormModal({ isOpen, onClose }: ContactFormModalProps) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Get in Touch"
    >
      <ContactForm 
        onSuccess={() => {
          setTimeout(() => {
            onClose();
          }, 2000);
        }}
      />
    </BaseModal>
  );
}